<template>
  <tr 
    class="cursor-pointer"
    @mousedown="mouseDown($event)"
    @mouseup="mouseUp"
  >
    <tippy 
      v-if="antivirusState === 'hasVirus'"
      :content="$t('File has virus')" 
      theme='warning'
      to="parent"
    />

    <td 
      v-if="antivirusState === 'hasVirus'"
      class="min-w-50 w-14 px-1 sm:p-0"
    >
      <aw-icon 
        icon="bug-report" 
        class="w-10 h-10 text-red-600"
      />
    </td>

    <td 
      v-else-if="hasPreview && !previewIsLoading" 
      class="min-w-50 w-14 px-1 sm:p-0"
    >
      <img :src="row.previews['500x500']" alt="" />
    </td>
    

    <td v-else class="py-3 px-4 sm:px-3" style="width: 50px;">
      {{ row.ext.substring(0, 3) }}
    </td>

    <td class="Table__Cell-Name py-2 px-3">
      <a :href="row.url" ref="link">{{ row.name }}</a>
    </td>
    <td class="py-2 px-3 text-center whitespace-nowrap">
      <ui-pictogram :user="row.uploaded_by__user" class="mr-2" />
      <span class="text-xs">
        {{ uploadedDate }}
      </span>
      <aw-icon 
        v-if="antivirusState === 'waiting'"
        icon="safety-check" 
        class="ml-1 w-4 h-4 text-gray-400"
        v-tippy="$t('File is being checked for viruses')"
      />
      <aw-icon 
        v-else-if="antivirusState === 'checked'"
        icon="verified-user" 
        class="ml-1 w-4 h-4 text-green-600"
        v-tippy="$t('File is safe')"
      />
      <aw-icon 
        v-else-if="antivirusState === 'hasVirus'"
        icon="bug-report" 
        class="ml-1 w-4 h-4 text-red-600"
      />
      <span
        v-else
        class="pl-1 w-4 h-4"
      />
    </td>
    <td class="py-2 px-2 text-right whitespace-nowrap">
      <!-- Mobile -->
      <div class="flex items-center justify-end cursor-pointer">
        <aw-icon
          icon="chevron-right"
          class="w-6 h-6 text-gray-400  "
        ></aw-icon>
      </div>

      <!-- Desktop -->
      <div class="flex items-center justify-end">
        <span
          ref="DocumentCircle"
          :data-item-index="rank"
          class="DocumentCircle inline-flex items-center mr-2.5"
          :class="{
            'DocumentCircle--active': bcSelectedStore.selected.has(row.id)
          }"
          @click.stop="bcSelectedStore.select(
            row, 
            {
              isRecursive: true,
              isShift: $event.shiftKey,
              itemIndex: rank,
            }
          )"
        ></span>
        <span
          class="inline-flex items-center cursor-pointer text-gray-400 hover:text-gray-500"
        >
          <!-- 
          <aw-dropdown
            placement="bottom-end"
            :offset="[0, 6]"
            class="cursor-pointer inline-flex items-center"
          >
            <template v-slot:btn="{ toggle }">
              <div @click.stop="toggle" class="inline-flex items-center">
                <aw-icon
                  icon="dots"
                  class="w-4 h-4 -mx-1 "
                ></aw-icon>
              </div>
            </template>
            <template v-slot:dropdown="{ opened, dropdown }">
              <div
                v-show="opened"
                :ref="dropdown"
                class="Dropdown Dropdown--Hover absolute rounded-md bg-white max-w-xs text-sm top-full right-0 shadow-md z-10"
              >
                <nav class="p-0 text-left">
                  <a class="block py-1.5 px-3 text-gray-600" href=""
                    >{{$('Add to favourites')}}</a
                  >
                  <a class="block py-1.5 px-3 text-gray-600" href=""
                    >{{$t('Edit button')}}</a
                  >
                  <a class="block py-1.5 px-3 text-gray-600" href=""
                    >{{$t('Move / Copy')}}}</a
                  >
                  <a class="block py-1.5 px-3 text-gray-600" href=""
                    >{{$t('Move to trash')}}}</a
                  >
                  <a class="block py-1.5 px-3 text-gray-600" href="">{{$t('Show')}}}</a>
                </nav>
              </div>
            </template>
          </aw-dropdown>
          -->
        </span>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import formatDate from 'nette-base-module/js/utils/formatDate'
import FileState from '../../mixins/FileState'
import Selected from '../../mixins/Selected'

export default {
  mixins: [
    FileState,
    Selected,
  ],
  props: ['rank', 'row'],
  data () {
    return {
      clickCounter: 0,
      clickTimeOut: null,
    }
  },
  computed: {
    ...mapStores(useBcSelectedStore),
    uploadedDate() {
      return formatDate(this.row.uploaded, 'd. m. Y')
    },
    file() {
      return this.row
    }
  },
  methods: {
    mouseDown ($event) {
      if ($event.target === this.$refs.DocumentCircle) {
        return
      }
      
      this.clickCounter = $event.detail
      if (this.clickTimeOut) {
        return
      }

      this.clickTimeOut = setTimeout(() => {
        this.clickTimeOut = null
      }, 250)
    },
    mouseUp () {
      if (this.clickTimeOut) {
        setTimeout(() => {
          if (this.clickCounter === 1) {
            this.$router.push(this.row.detail_url.replace(/^(?:\/\/|[^/]+)*\//, ''))
          }
        }, 140)
      }
    }
  },
  mounted() {
    this.assignItemToSelectBtn('DocumentCircle', this.row)
  }
}
</script>

<style lang="scss" scoped>
td:last-child {
  > div:first-child {
    @apply hidden;
  }

  > div:first-child + div {
    @apply flex;
  }
}

@media (max-width: 600px) {
  td:nth-child(3),
  td:nth-child(4) {
    @apply hidden;
  }

  td:last-child {
    > div:first-child {
      @apply flex;
    }

    > div:first-child + div {
      @apply hidden;
    }
  }
}
</style>
